// extracted by mini-css-extract-plugin
export var copyIcon = "_r5-2";
export var discountCard = "_r5-0";
export var discountCode = "_r5-3";
export var discountContent = "_r5-1";
export var loadingCard = "_r5-4";